/* eslint-disable react/prop-types */
import { createRef, useEffect, useState } from "react"
import { Button, Form, Modal } from "react-bootstrap"
import DatePicker from "react-datepicker"
import { useDispatch, useSelector } from "react-redux"
import {
    bindYourQuote,
    deleteLossRunsFiles,
    deleteSignedApplicationFile,
    downloadLossRunsFiles,
    downloadSignedApplicationFile,
    getApplication,
    getBindFiles,
    uploadLossRunFile,
    uploadSignedApplicationFile,
    actions,
    uploadSurplusLineFiles,
    uploadTriaFiles,
    downloadSurplusLinesFiles,
    deleteSurplusLinesFiles,
    downloadTriaFiles,
    deleteTriaFiles
} from "../../../data/applicationSlice"
import { downloadFile } from "../../../constant/utils"
import Loader from "../../../components/Loader"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { byPrefixAndName } from "@awesome.me/kit-de80aecb6a/icons"
import { css } from "@emotion/react"
import "react-datepicker/dist/react-datepicker.css"
const { clearApplicationData } = actions

const { clearBindingData } = actions

const componentStyles = css`
    ul {
        margin: 0;
        padding: 0;
        padding-left: 20px;
    }

    .react-datepicker__input-container input {
        height: 34px;
        display: block;
        width: 100%;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: var(--bs-body-color);
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-color: var(--bs-body-bg);
        background-clip: padding-box;
        border: var(--bs-border-width) solid var(--bs-border-color);
        border-radius: var(--bs-border-radius);
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .react-datepicker-wrapper {
        display: inline-block;
    }

    .react-datepicker__input-container input {
        width: 100%;
        box-sizing: border-box;
    }

    .react-datepicker {
        z-index: 9999;
    }

    .react-datepicker__triangle {
        display: none;
    }
`

export const BinderModal = ({ show, hide, applicationId, refetchApplications }) => {
    const dispatch = useDispatch()

    const [coverageOption, setCoverageOption] = useState("")
    const [desiredEffectiveDate, setDesiredEffectiveDate] = useState()
    const [bindEffectiveDate, setBindEffectiveDate] = useState(null)
    const [errorMessage, setErrorMessage] = useState("")
    const [showTriaUploadOption, setShowTriaUploadOption] = useState(false)
    const signedApplicationRef = createRef()
    const lossRunRef = createRef()
    const surplusLinesRef = createRef()
    const triaFilesRef = createRef()

    const {
        fetchStatus,
        application,
        bindFiles: { signedApplication, lossRuns, surplusLines, tria }
    } = useSelector((state) => state.application)

    const hasSignedApplication = Object.keys(signedApplication)?.length > 0

    useEffect(() => {
        if (applicationId && show) {
            dispatch(getApplication(applicationId)).then(({ payload }) => {
                if (payload.firstNamedInsuredState === "FL") {
                    setShowTriaUploadOption(true)
                }
                if (payload.dateEffectiveUtc === null) {
                    setDesiredEffectiveDate("")
                } else {
                    setDesiredEffectiveDate(new Date(payload.dateEffectiveUtc))
                }
                setBindEffectiveDate(null)
                dispatch(getBindFiles(applicationId))
            })
        }
        if (!show && (hasSignedApplication || lossRuns?.length)) {
            dispatch(clearBindingData())
        }
        if (!show && errorMessage) {
            setErrorMessage("")
        }
        if (!show && coverageOption) {
            setCoverageOption("")
        }
    }, [applicationId, show])

    const uploadSignedApplication = (event) => {
        const file = event.target.files[0]
        if (file) {
            const formData = new FormData()
            formData.append("file", file)

            let payload = {
                id: applicationId,
                binary: formData
            }
            dispatch(uploadSignedApplicationFile(payload)).then(({ payload }) => {
                if (payload?.succeeded) {
                    event.target.value = null
                    dispatch(getBindFiles(applicationId))
                }
            })
        }
    }

    const handleLossRunChange = (event) => {
        const files = event.target.files[0]
        if (files) {
            const formData = new FormData()
            formData.append("file", files)

            let payload = {
                id: applicationId,
                binary: formData
            }
            dispatch(uploadLossRunFile(payload)).then(({ payload }) => {
                if (payload?.succeeded) {
                    event.target.value = null
                    dispatch(getBindFiles(applicationId))
                }
            })
        }
    }

    const handleSurplusLineChange = (event) => {
        const files = event.target.files
        if (files) {
            const formData = new FormData()
            formData.append("file", files[0])

            let payload = {
                id: applicationId,
                binary: formData
            }
            dispatch(uploadSurplusLineFiles(payload)).then(({ payload }) => {
                if (payload?.succeeded) {
                    dispatch(getBindFiles(applicationId))
                }
            })
        }
    }

    const handleTriaFormChange = (event) => {
        const files = event.target.files
        if (files) {
            const formData = new FormData()
            formData.append("file", files[0])

            let payload = {
                id: applicationId,
                binary: formData
            }

            dispatch(uploadTriaFiles(payload)).then(({ payload }) => {
                if (payload?.succeeded) {
                    dispatch(getBindFiles(applicationId))
                }
            })
        }
    }

    const handleSendClick = () => {
        let coverage = ""
        let coverageId = ""

        // using coverageOptions as name to find the object with same name from application.limitsAndRetentions
        application.limitsAndRetentions.forEach((option) => {
            if (option.id === coverageOption) {
                coverage = option.name
                coverageId = option.id
            }
        })

        const selectedOption = application.limitsAndRetentions.find((option) => option.id === coverageOption)
        const selectedOptionIndex = selectedOption ? application.limitsAndRetentions.indexOf(selectedOption) : -1

        const coverageDisplayName = selectedOption
            ? `Opt ${selectedOptionIndex + 1} - Limit $${(selectedOption.eachLossLimit / 1000000).toFixed(0)}M/$${(
                  selectedOption.aggregateLimit / 1000000
              ).toFixed(0)}M - SIR $${(convertRetention(selectedOption.retention) / 1000).toFixed(0)}K`
            : ""

        const payload = {
            id: applicationId,
            coverage: selectedOption?.name ?? "",
            coverageDisplayName,
            coverageId: selectedOption?.id ?? "",
            bindEffectiveDate: bindEffectiveDate ? new Date(bindEffectiveDate).toISOString() : null
        }

        dispatch(bindYourQuote(payload)).then(({ payload }) => {
            if (payload?.succeeded) {
                hideBinderModal()
                refetchApplications()
            } else if (!payload?.succeeded && payload?.errorMessage) {
                setErrorMessage(payload?.errorMessage)
            }
        })
    }

    const hideBinderModal = () => {
        setShowTriaUploadOption(false)
        if (Object.keys(application).length > 0) {
            dispatch(clearApplicationData())
            hide()
        } else {
            hide()
        }
    }

    const handleCoverageOption = (event) => {
        setCoverageOption(event.target.value)
    }

    const downloadLossRunsFile = (id) => {
        dispatch(downloadLossRunsFiles(id)).then(({ payload }) => {
            if (payload?.file) {
                downloadFile(payload)
            }
        })
    }

    const deleteLossRunsFile = (id) => {
        dispatch(deleteLossRunsFiles(id)).then(({ payload }) => {
            if (payload?.succeeded) {
                dispatch(getBindFiles(applicationId))
            }
        })
    }

    const downloadSurplusFile = (id) => {
        dispatch(downloadSurplusLinesFiles(id)).then(({ payload }) => {
            if (payload?.file) {
                downloadFile(payload)
            }
        })
    }

    const deleteSurplusFile = (id) => {
        if (surplusLinesRef.current.value) {
            surplusLinesRef.current.value = null
        }
        dispatch(deleteSurplusLinesFiles(id)).then(({ payload }) => {
            if (payload?.succeeded) {
                dispatch(getBindFiles(applicationId))
            }
        })
    }

    const downloadTriaFile = (id) => {
        dispatch(downloadTriaFiles(id)).then(({ payload }) => {
            if (payload?.file) {
                downloadFile(payload)
            }
        })
    }

    const deleteTriaFile = (id) => {
        if (triaFilesRef?.current?.value) {
            triaFilesRef.current.value = null
        }
        dispatch(deleteTriaFiles(id)).then(({ payload }) => {
            if (payload?.succeeded) {
                dispatch(getBindFiles(applicationId))
            }
        })
    }

    const downloadSignedApplication = (id) => {
        dispatch(downloadSignedApplicationFile(id)).then(({ payload }) => {
            if (payload?.file) {
                downloadFile(payload)
            }
        })
    }

    const deleteSignedApplication = (id) => {
        dispatch(deleteSignedApplicationFile(id)).then(({ payload }) => {
            if (payload?.succeeded) {
                dispatch(getBindFiles(applicationId))
            }
        })
    }

    const formatInsuranceInfo = (data) => {
        const eachLossLimit = data.eachLossLimit || 0
        const aggregateLimit = data.aggregateLimit || 0
        const retention = convertRetention(data.retention)

        return `Limit $${(eachLossLimit / 1000000).toFixed(1)}M/$${(aggregateLimit / 1000000).toFixed(1)}M - SIR $${(
            retention / 1000
        ).toFixed(0)}K`
    }

    const convertRetention = (retention) => {
        const retentionMap = {
            OneThousand: 1000,
            TwoThousand: 2000,
            ThreeThousand: 3000,
            FourThousand: 4000,
            FiveThousand: 5000,
            TenThousand: 10000,
            FifteenThousand: 15000,
            TwentyThousand: 20000,
            TwentyFiveThousand: 25000,
            FiftyThousand: 50000,
            SeventyFiveThousand: 75000,
            OneHundredThousand: 100000,
            FiveHundredThousand: 500000,
            OneMillion: 1000000
        }

        return retentionMap[retention] || 0
    }

    return (
        <>
            <Modal
                show={show}
                onHide={hideBinderModal}
                size="md"
                centered
                keyboard={false}
                backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title> Bind Your Quote</Modal.Title>
                </Modal.Header>
                <Modal.Body css={componentStyles}>
                    <Loader show={fetchStatus === "loading"} />
                    <Form.Group
                        className="mb-3"
                        controlId="option">
                        <Form.Label>
                            Coverage<span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                            aria-label="select"
                            name="option"
                            value={coverageOption}
                            onChange={(e) => handleCoverageOption(e)}>
                            <option value={""}>--- Select ---</option>
                            {application?.limitsAndRetentions?.map((option, index) => (
                                <option
                                    key={option?.id}
                                    value={option.id}>
                                    {`Opt ${index + 1} - Limit $${(option?.eachLossLimit / 1000000).toFixed(0)}M/$${(
                                        option?.aggregateLimit / 1000000
                                    ).toFixed(0)}M - SIR $${(convertRetention(option?.retention) / 1000).toFixed(0)}K`}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    {desiredEffectiveDate && (
                        <Form.Group>
                            <Form.Label>Desired effective date of coverage</Form.Label>
                            <DatePicker
                                selected={desiredEffectiveDate}
                                onChange={(date) => {
                                    setDesiredEffectiveDate(date)
                                }}
                                readOnly
                                placeholderText="No Date provided"
                                dateFormat="MM/dd/yyyy"
                                popperPlacement="bottom"
                                popperModifiers={[
                                    {
                                        name: "arrow"
                                    }
                                ]}
                                className="form-control form-control-sm"
                            />
                        </Form.Group>
                    )}
                    <Form.Group
                        className="mb-2 mt-2"
                        controlId="signedApplication">
                        <Form.Label>
                            Upload Signed Application<span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="file"
                            accept=".pdf, .doc, .docx"
                            name="signatureFile"
                            disabled={hasSignedApplication}
                            onChange={uploadSignedApplication}
                            ref={signedApplicationRef}
                        />
                    </Form.Group>
                    {hasSignedApplication && <strong>Uploaded Signed Application:</strong>}
                    {hasSignedApplication && (
                        <ul>
                            <li>
                                <span>{signedApplication?.name}</span>
                                <Button
                                    disabled={!signedApplication?.id}
                                    onClick={() => downloadSignedApplication(signedApplication.id)}
                                    variant="light"
                                    className="btn-sm ms-2 me-2"
                                    title="Download Loss Run PDF">
                                    <FontAwesomeIcon icon={byPrefixAndName.fal["download"]} />
                                </Button>
                                <Button
                                    disabled={!signedApplication?.id}
                                    onClick={() => deleteSignedApplication(signedApplication.id)}
                                    variant="light"
                                    className="btn-sm"
                                    title="Delete Loss Run file">
                                    <FontAwesomeIcon
                                        icon={byPrefixAndName.fal["trash"]}
                                        className="icon-red"
                                    />
                                </Button>
                            </li>
                        </ul>
                    )}
                    <Form.Group
                        className="mb-2"
                        controlId="lossRuns">
                        <Form.Label>
                            Upload Loss Runs<span className="text-danger">*</span> (multiple unlocked PDF or Excel files
                            are accepted)
                        </Form.Label>
                        <Form.Control
                            type="file"
                            accept=".pdf, .doc, .docx"
                            name="lossRunApplication"
                            onChange={handleLossRunChange}
                            ref={lossRunRef}
                        />
                    </Form.Group>
                    {lossRuns?.length > 0 && <strong>Uploaded Loss Runs:</strong>}
                    {lossRuns?.map((file) => (
                        <ul key={file?.id}>
                            <li>
                                <span>{file?.name}</span>
                                <Button
                                    disabled={!file?.id}
                                    onClick={() => downloadLossRunsFile(file.id)}
                                    variant="light"
                                    className="btn-sm ms-2 me-2"
                                    title="Download Loss Run PDF">
                                    <FontAwesomeIcon icon={byPrefixAndName.fal["download"]} />
                                </Button>
                                <Button
                                    disabled={!file?.id}
                                    onClick={() => deleteLossRunsFile(file.id)}
                                    variant="light"
                                    className="btn-sm"
                                    title="Delete Loss Run file">
                                    <FontAwesomeIcon
                                        icon={byPrefixAndName.fal["trash"]}
                                        className="icon-red"
                                    />
                                </Button>
                            </li>
                        </ul>
                    ))}
                    <Form.Group
                        className="mb-2 mt-2"
                        controlId="surplusForm">
                        <Form.Label>Upload Surplus Lines Form</Form.Label>
                        <Form.Control
                            disabled={surplusLines?.length > 0}
                            type="file"
                            accept=".pdf, .doc, .docx"
                            name="surplusFile"
                            multiple={false}
                            onChange={(e) => {
                                handleSurplusLineChange(e)
                            }}
                            ref={surplusLinesRef}
                        />
                    </Form.Group>
                    {surplusLines?.length > 0 && <strong>Uploaded Surplus Line Forms:</strong>}
                    {surplusLines?.map((file) => (
                        <ul key={file?.id}>
                            <li>
                                <span>{file?.name}</span>
                                <Button
                                    disabled={!file?.id}
                                    onClick={() => downloadSurplusFile(file.id)}
                                    variant="light"
                                    className="btn-sm ms-2 me-2"
                                    title="Download Loss Run PDF">
                                    <FontAwesomeIcon icon={byPrefixAndName.fal["download"]} />
                                </Button>
                                <Button
                                    disabled={!file?.id}
                                    onClick={() => deleteSurplusFile(file.id)}
                                    variant="light"
                                    className="btn-sm"
                                    title="Delete Loss Run file">
                                    <FontAwesomeIcon
                                        icon={byPrefixAndName.fal["trash"]}
                                        className="icon-red"
                                    />
                                </Button>
                            </li>
                        </ul>
                    ))}
                    {showTriaUploadOption && (
                        <>
                            <Form.Group
                                className="mb-2 mt-2"
                                controlId="surplusForm">
                                <Form.Label>Upload TRIA Form</Form.Label>
                                <Form.Control
                                    disabled={tria?.length > 0}
                                    type="file"
                                    accept=".pdf, .doc, .docx"
                                    name="triaFile"
                                    multiple={true}
                                    onChange={(e) => {
                                        handleTriaFormChange(e)
                                    }}
                                    ref={triaFilesRef}
                                />
                            </Form.Group>
                            {tria?.length > 0 && <strong>Uploaded Tria Forms:</strong>}
                            {tria?.map((file) => (
                                <ul key={file?.id}>
                                    <li>
                                        <span>{file?.name}</span>
                                        <Button
                                            disabled={!file?.id}
                                            onClick={() => downloadTriaFile(file.id)}
                                            variant="light"
                                            className="btn-sm ms-2 me-2"
                                            title="Download Loss Run PDF">
                                            <FontAwesomeIcon icon={byPrefixAndName.fal["download"]} />
                                        </Button>
                                        <Button
                                            disabled={!file?.id}
                                            onClick={() => deleteTriaFile(file.id)}
                                            variant="light"
                                            className="btn-sm"
                                            title="Delete Loss Run file">
                                            <FontAwesomeIcon
                                                icon={byPrefixAndName.fal["trash"]}
                                                className="icon-red"
                                            />
                                        </Button>
                                    </li>
                                </ul>
                            ))}
                        </>
                    )}

                    <Form.Group>
                        <Form.Label>
                            Bind Effective Date<span className="text-danger">*</span>
                        </Form.Label>
                        <DatePicker
                            selected={bindEffectiveDate ? new Date(bindEffectiveDate) : null}
                            onChange={(date) => {
                                setBindEffectiveDate(date)
                            }}
                            dateFormat="MM/dd/yyyy"
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className="d-block">
                    <div className="d-flex justify-content-end">
                        <Button
                            variant="secondary"
                            className="btn-sm"
                            onClick={hideBinderModal}>
                            Close
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleSendClick}
                            className="ms-2 btn-sm"
                            disabled={
                                !hasSignedApplication || !lossRuns?.length > 0 || !coverageOption || !bindEffectiveDate
                            }>
                            Send
                        </Button>
                    </div>

                    {errorMessage && (
                        <div className="d-flex justify-content-end">
                            <Form.Text className="text-danger text-right">{errorMessage}</Form.Text>
                        </div>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    )
}
